import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
export var LevelNodesSection = function LevelNodesSection(_ref) {
  var visibleWhen = _ref.visibleWhen,
    children = _ref.children,
    title = _ref.title;
  if (visibleWhen === false) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, title), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), children);
};